export class OrderBillItem {
  public id: string;
  public menuItemId:	string;
  public orderBillId: string;
  public totalQuantity: number;
  public quantity: number;
  public splittedItems: [];
  public orderBillItemCorrections: [];
  public venueMenuItemName: string;
  public venueMenuItemPrice: number;
  public venueMenuItemPriceWithTax: number;
  public venueMenuItemTaxRateName: string;
  public venueMenuItemTaxRateRate: number;


}
